var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivateLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44922 7.42672C7.44922 4.91287 9.48709 2.875 12.0009 2.875C14.5148 2.875 16.5527 4.91287 16.5527 7.42672V9.49569C16.5527 9.95275 16.1822 10.3233 15.7251 10.3233C15.268 10.3233 14.8975 9.95275 14.8975 9.49569V7.42672C14.8975 5.827 13.6007 4.53017 12.0009 4.53017C10.4012 4.53017 9.10439 5.827 9.10439 7.42672V9.49569C9.10439 9.95275 8.73386 10.3233 8.2768 10.3233C7.81975 10.3233 7.44922 9.95275 7.44922 9.49569V7.42672Z",
    fill: "#FF9355"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03367 8.875C5.77667 8.875 4.7577 9.89407 4.75781 11.1511L4.7585 18.5994C4.75862 19.8562 5.77752 20.875 7.03436 20.875H16.9645C18.2215 20.875 19.2404 19.8561 19.2404 18.5991V11.1509C19.2404 9.89394 18.2215 8.875 16.9645 8.875H7.03367ZM12.8268 14.0474C12.8268 13.5903 12.4563 13.2198 11.9992 13.2198C11.5421 13.2198 11.1716 13.5903 11.1716 14.0474V15.7026C11.1716 16.1597 11.5421 16.5302 11.9992 16.5302C12.4563 16.5302 12.8268 16.1597 12.8268 15.7026V14.0474Z",
    fill: "#FF9355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateLockIcon);
export default __webpack_public_path__ + "static/media/private-lock-icon.e55219571acf9bc9c0a6f83106d5d1ae.svg";
export { ForwardRef as ReactComponent };